import {$$, $} from "./dom.js";
const matchFn = (node, filter, key) => {
	if (filter === "" || !filter || !node.dataset) {
		return true;
	}

	const value = node.dataset[key];
	if (!value) {
		return true;
	}

	return value.toLocaleLowerCase().indexOf(filter) >= 0;
};

function B6FilterFrom(node) {
	const filterkey = node.dataset["b6Filterkey"];
	const input = /** @type {HTMLInputElement} */ ($(node.dataset["b6Filterfrom"]));

	input.addEventListener("keyup", () => {
		const lowercaseValue = input.value.toLocaleLowerCase();
		node.childNodes.forEach((record) => {
			if (record.nodeType === 3) return;

			if (matchFn(record, lowercaseValue, filterkey)) {
				record.style.display = "";
			} else {
				record.style.display = "none";
			}
		});
	});
}

export function Register(root) {
	if (!root) {
		root = document;
	}

	$$("[data-b6-filterfrom]", root).forEach((domElement) => {
		B6FilterFrom(domElement);
	});
}
